import { ReactNode } from "react";
import NoCompanyAccess from "../components/common/NoCompanyAccess";

interface Props {
  companies: any[] | undefined;
  children: ReactNode;
}

export default function RequireHasCompanies({
  companies,
  children,
}: Props) {
  // jeszcze się ładuje
  if (companies === undefined) {
    return null; // albo spinner
  }

  // brak przypisanych firm
  if (companies.length === 0) {
    return <NoCompanyAccess />;
  }

  return <>{children}</>;
}
